import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-carousel-file-viewer',
  templateUrl: './carousel-file-viewer.component.html',
  styleUrls: ['./carousel-file-viewer.component.css']
})
export class CarouselFileViewerComponent implements OnInit {
  @Input() divClassName = '';
  @Input() set filesDatas(files: { name: string, guid: string, date: string, fileData: any }[]) {
    this.files = files;
    console.log(files);
  }

  private _files: { name: string, guid: string, date: string, fileData: any }[] = [];
  @Input() set files(files: { name: string, guid: string, date: string, fileData: any }[]) {
    this._files = files;
  }
  get files(): { name: string, guid: string, date: string, fileData: any }[] {
    return this._files;
  }
  @Input() canShare = false;
  @Input() removeElements = false;

  @Output() removeElementsEvent = new EventEmitter<{ name: string, guid: string, date: string, fileData: any }[]>();

  constructor() { }

  ngOnInit() {
  }

  removeElement(file: { name: string, guid: string, date: string, fileData: any }) {
    const element = this.files.find(fil => fil.name == file.name && fil.guid == file.guid && fil.date == file.date);
    this.removeElementsEvent.emit([element]);
  }

  removeAllFiles() {
    this.removeElementsEvent.emit(this.files);
  }

}
